import { Offering } from '@arrived/models';

export const getTotalPropertyAmount = (offering: Offering) =>
  offering.totalPurchasePrice +
  offering.arrivedOneTimeProceeds +
  offering.closingOfferingAndHoldingCosts +
  offering.propertyImprovementsAndCashReserves;
